import { api } from '@/shared/api/client';

export type SearchKind =
  | 'employee'
  | 'document'
  | 'news'
  | 'partner-offer'
  | 'internal-benefit'
  | 'course';

export interface SearchHit {
  readonly kind: SearchKind;
  readonly id: number;
  readonly title: string;
  readonly subtitle: string;
}

export interface GlobalSearchResult {
  readonly hits: SearchHit[];
  readonly tooShort: boolean;
}

/**
 * `limit` is per kind, not in total. The palette asks for a few; the results page asks for
 * the ceiling and says so when a kind reaches it — a page titled "all results" that
 * quietly truncated would be worse than one that admits its bound.
 */
export const RESULTS_PAGE_LIMIT = 50;

export function globalSearch(
  q: string,
  limit?: number,
  signal?: AbortSignal,
): Promise<GlobalSearchResult> {
  return api.get<GlobalSearchResult>('/search', { query: { q, limit }, signal });
}
